import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig'

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
  

	
	return token ? <Navigate to={AUTH_PREFIX_PATH} /> : <Outlet/>
}

export default PublicRoute